import { IBusiness } from '../entities/businessBase';

/**
 * 取引のファクトリークラス
 */
export class BusinessFactory {
  /**
   * IBusinessを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<IBusiness> = {}): IBusiness => {
    const business: Required<IBusiness> = {
      businessId: initialData.businessId ?? '',
      organizationId: initialData.organizationId ?? '',
      dataId: initialData.dataId ?? '',
      salesDestinationName: initialData.salesDestinationName,
      salesDestinationNumber: initialData.salesDestinationNumber,
      MOQ: initialData.MOQ,
      orderPackage: initialData.orderPackage,
      note: initialData.note,
      leadTime: initialData.leadTime,
      leadTimeUnit: initialData.leadTimeUnit,
      group: initialData.group,
      aggregateGroup: initialData.aggregateGroup,
      virtualChild: initialData.virtualChild,
      isTrashed: initialData.isTrashed,
      createAt: initialData.createAt,
      customerName: initialData.customerName,
      customerNumber: initialData.customerNumber,
      businessName: initialData.businessName,
      unit: initialData.unit,
      deliveryDestinationName: initialData.deliveryDestinationName,
      executionDate: initialData.executionDate,
      businessMemo: initialData.businessMemo,
      salesResults: initialData.salesResults ?? [],
      arrivals: initialData.arrivals ?? [],
      customerAnnounce: initialData.customerAnnounce ?? [],
      customerAnnounceDaily: initialData.customerAnnounceDaily ?? [],
      warehouse: initialData.warehouse ?? '',
      warehouseNumber: initialData.warehouseNumber ?? '',
      package: initialData.package ?? '',
      businessNumber: initialData.businessNumber ?? '',
      supplierName: initialData.supplierName ?? '',
      supplierNumber: initialData.supplierNumber ?? '',
      recommend: initialData.recommend ?? [],
      dataType: initialData.dataType,
      businessForecastState: initialData.businessForecastState,
      updatedAt: initialData.updatedAt,
      createdAt: initialData.createdAt,
      removeAt: initialData.removeAt,
      deleted: initialData.deleted,
      stdInventoryIndices: initialData.stdInventoryIndices,
      inventory: initialData.inventory,
      supplierAnnounce: initialData.supplierAnnounce,
      mvpInventory: initialData.mvpInventory,
      forecastForReceiptId: initialData.forecastForReceiptId,
      forecastForReceiptName: initialData.forecastForReceiptName,
      forecastForReceiptResponsibleUsers: initialData.forecastForReceiptResponsibleUsers ?? [],
      aggregateBusinessResponsibleUsers: initialData.aggregateBusinessResponsibleUsers ?? [],
      baseBusinessResponsibleUsers: initialData.baseBusinessResponsibleUsers ?? [],
      manufacturer: initialData.manufacturer,
      endUser: initialData.endUser,
      lastCheckedUser: initialData.lastCheckedUser,
      lastCheckedAt: initialData.lastCheckedAt,
      userUniqueNumber: initialData.userUniqueNumber,
    };

    return business;
  };
}
